import React, { Component } from 'react';
import styled from 'styled-components';
import algoliasearch from 'algoliasearch/lite';
import qs from 'qs';
import {
  InstantSearch,
  Hits,
  Pagination,
  ClearRefinements,
  Configure,
  Panel
} from 'react-instantsearch-dom';
import CustomCurrentRefinements from './customWidgets/CustomCurrentRefinements';
import CustomPanel from './customWidgets/CustomPanel';
import CustomHits from './customWidgets/CustomHits';
import CustomRefinementList from './customWidgets/CustomRefinementList';
import InfiniteHits from './customWidgets/InfiniteHits';
import getAlgoliaIndex from '../../../../utils/getAlgoliaIndex';

const SearchWrapper = styled.div`
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 150px;
  background-color: #ffffff;

  .filters-container {
    display: grid;
    align-items: center;
    grid-gap: 10px;
    padding-bottom: 10px;
    /* grid-template-areas: 2fr 3fr 3fr 3fr 4fr; */
    grid-template-areas: 'color material pattern';

    .color-panel {
      grid-area: color;
    }
    .pattern-panel {
      grid-area: pattern;
    }
    .material-panel {
      grid-area: material;
    }
    .filter-by-panel {
      position: relative;
      grid-area: filter;
    }
    .kid-friendly-toggle {
      grid-area: kid;
    }
  }

  .kid-friendly-refinement {
    border: 1px solid grey;
  }

  .clear-filters--filters-container {
    margin-bottom: 10px;
  }

  .filters-container-algolia {
    max-width: 1300px !important;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 992px) {
    .custom-hits-sort-by-container {
      padding: 0 10px;
    }
    .filters-container-algolia {
      position: sticky;
      top: 60px;
      z-index: 8;
    }
    .filters-container {
      border-bottom: none;
    }
    .color-panel {
    }

    .material-panel {
      border-left: none;
    }
    .kid-friendly-toggle {
      height: 100%;
      border-top: none;
      border-left: none;
    }

    .filters-container {
      grid-template-columns: 1fr 1fr;
      grid-template-areas: none;

      .pattern-panel {
        margin-top: 5px !important;
        grid-column: span 2;
      }
    }

    .clear-filters--filters-container {
      padding: 0 10px;
      margin-bottom: 0px;
    }
    .ais-Panel-body {
      top: 69px;
    }

    .pattern-panel .ais-Panel-body {
      top: 129px;
    }
  }
  @media (max-width: 768px) {
    margin-top: 0px;
  }
  .filters {
    background: #ffffff 0% 0% no-repeat padding-box;
    /* box-shadow: 0px 10px 20px #00000014; */
    /* padding: 0px 15px 20px 15px; */
  }
  [class^='ais-'] {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
  }
  .ais-Breadcrumb,
  .ais-ClearRefinements,
  .ais-CurrentRefinements,
  .ais-GeoSearch,
  .ais-HierarchicalMenu,
  .ais-Hits,
  .ais-Results,
  .ais-HitsPerPage,
  .ais-ResultsPerPage,
  .ais-InfiniteHits,
  .ais-InfiniteResults,
  .ais-Menu,
  .ais-MenuSelect,
  .ais-NumericMenu,
  .ais-NumericSelector,
  .ais-Pagination,
  .ais-Panel,
  .ais-PoweredBy,
  .ais-RangeInput,
  .ais-RangeSlider,
  .ais-RatingMenu,
  .ais-RefinementList,
  .ais-SearchBox,
  .ais-SortBy,
  .ais-Stats,
  .ais-ToggleRefinement {
    color: ${({ theme }) => theme.colors.charcoal};
  }
  .stats-container {
    height: 30px;
    margin-bottom: 0;
  }
  .ais-Stats,
  .ais-CurrentRefinements {
    display: inline-block;
  }
  .ais-Stats {
    letter-spacing: 0.8px;
    margin-right: 20px;
  }
  .ais-CurrentRefinements-item {
    border-radius: 0;
    background-color: ${({ theme }) => theme.colors.limoncello};
  }
  .ais-Panel {
    margin-top: 0px;
    .ais-Panel-header {
      letter-spacing: 0.8px;
      color: #787878;
      text-transform: uppercase;
      font-weight: normal;
      cursor: pointer;
    }
    .ais-RefinementList-list {
      margin-bottom: 20px;
    }
  }
  .filter-by {
    color: ${({ theme }) => theme.colors.charcoal};
    font-weight: 800;
    float: left;
    font-size: 0.8rem;
  }
  .ais-ClearRefinements-button {
    margin: 5px 0;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.french};
    text-transform: uppercase;
    float: right;
    padding: 0;
    cursor: pointer;
    &.ais-ClearRefinements-button--disabled {
      display: none;
    }
  }

  .rheostat {
    margin-top: 6px;
    margin-right: 12px;
    margin-left: 0;
    .rheostat-progress {
      background-color: ${({ theme }) => theme.colors.limoncello};
      top: 0;
      height: 2px;
    }
    .rheostat-background {
      height: 1px;
      border-color: #8080803d;
    }
    .rheostat-handle + .rheostat-handle {
      margin-left: -7px;
    }
    .rheostat-handle {
      background-color: ${({ theme }) => theme.colors.limoncello};
      border: 1px solid #2a5caf;
      border-radius: 100%;
      top: -8px;
      padding: 0;
      margin: 0;
      &:before,
      &:after {
        content: none;
      }
    }
    .rheostat-marker {
      background-color: transparent;
      .rheostat-value.right {
        margin-left: -10px;
      }
      .rheostat-value.left {
        margin-left: 12px;
      }
    }
  }
  .ais-RefinementList-list {
    list-style-type: none;
    padding-left: 0;
    .ais-RefinementList-label {
      cursor: pointer;
    }
    .ais-RefinementList-labelText {
      margin-left: 8px;
      color: ${({ theme }) => theme.colors.charcoal};
    }
    .ais-RefinementList-count {
      background-color: transparent;
      color: #7d7d7d;
    }
  }
  .ais-ToggleRefinement {
    .ais-ToggleRefinement-label {
      margin: 0;
      cursor: pointer;
    }
    .ais-ToggleRefinement-labelText {
      margin-left: 8px;
    }
    .ais-ToggleRefinement-count {
      background-color: transparent;
      color: #7d7d7d;
    }
  }
  .custom-checkbox {
    display: inline-block;
  }
  .ais-SearchBox-input {
    border: 1px solid #ced4da;
    border-radius: 0;
    color: #495057;
    font-size: 16px;
  }
  .ais-SearchBox-input {
    &::-webkit-input-placeholder {
      color: #aaaaaa;
    }
    &::-moz-placeholder {
      color: #aaaaaa;
    }
    &::-ms-input-placeholder {
      color: #aaaaaa;
    }
    &::-moz-placeholder {
      color: #aaaaaa;
    }
  }

  .ais-Pagination {
    margin-top: 40px;
    .ais-Pagination-link {
      color: ${({ theme }) => theme.colors.charcoal};
      border-radius: 0;
      text-align: center;
      width: 36px;
    }
    .ais-Pagination-item--selected {
      .ais-Pagination-link {
        color: #fff;
        background-color: ${({ theme }) => theme.colors.limoncello};
        border-color: ${({ theme }) => theme.colors.french};
      }
    }
    .ais-Pagination-item + .ais-Pagination-item {
      margin-left: 12px;
    }
    @media (max-width: 500px) {
      .ais-Pagination-link {
        width: 26px;
        padding: 0.1rem 0.4rem;
      }
      .ais-Pagination-item + .ais-Pagination-item {
        margin-left: 6px;
      }
    }
  }
  .ais-CurrentRefinements-category {
    margin-left: 0;
    .ais-CurrentRefinements-item {
      background-color: ${({ theme }) => theme.colors.limoncello};
      color: white;
    }
  }
`;

const searchClient = algoliasearch(
  window.algoliaAppId,
  window.algoliaClientSecret
);

const updateAfter = 700;

const createURL = state => {
  let url = `?${qs.stringify(state)}`;
  url.replace('toggle%5Bis_kid%5D=false&', '');
  return url;
};

const searchStateToUrl = (props, searchState) =>
  searchState ? `${props.location.pathname}${createURL(searchState)}` : '';
const urlToSearchState = location => {
  return qs.parse(location.search.slice(1));
};

class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchState: urlToSearchState(props.location)
    };
  }

  handleFilterOpen = () => {
    this.props.setFilterOpen(!this.props.filterOpen);
  };

  componentWillReceiveProps(props) {
    if (props.location !== this.props.location) {
      this.setState({
        searchState: urlToSearchState(props.location)
      });
    }
  }

  onSearchStateChange = searchState => {
    clearTimeout(this.debouncedSetState);
    this.debouncedSetState = setTimeout(() => {
      this.props.history.push(
        searchStateToUrl(this.props, searchState),
        searchState
      );
    }, updateAfter);
    if (searchState.toggle && !searchState.toggle.is_kid) {
      delete searchState.toggle;
    }
    this.setState({ searchState });
  };

  render() {
    return (
      <SearchWrapper
        filterOpen={this.props.filterOpen}
        className={`container mt-4 ${
          this.props.modal ? 'search-on-modal' : ''
        }`}
      >
        {this.props.modal && (
          <span
            className={'close-search-page'}
            onClick={() => {
              this.props.setShowSearch(false);
            }}
          >
            <i
              className="far fa-times-circle fa-2x"
            />
          </span>
        )}
        <div className="ais-InstantSearch">
          <InstantSearch
            indexName={getAlgoliaIndex('products')}
            searchClient={searchClient}
            searchState={this.state.searchState}
            onSearchStateChange={this.onSearchStateChange}
            createURL={createURL}
          >
            <div className="grid">
              <div className="filters-container-algolia">
                <div className="filters">
                  <Configure
                    clickAnalytics
                    hitsPerPage={12}
                    query={this.props.query}
                  />

                  <div className="filters-container">
                    <CustomPanel
                      header="Color"
                      isMobile={this.props.isMobile}
                      className="mt-4"
                    >
                      <CustomRefinementList
                        searchable
                        attribute="colors"
                        limit={100}
                      />
                    </CustomPanel>
                    <CustomPanel
                      header="Material"
                      isMobile={this.props.isMobile}
                      className="mt-4"
                    >
                      <CustomRefinementList
                        searchable={false}
                        attribute="material"
                        limit={100}
                      />
                    </CustomPanel>
                    <CustomPanel
                      header="Pattern"
                      className="pattern-panel mt-4"
                    >
                      <CustomRefinementList
                        searchable
                        attribute="pattern"
                        limit={100}
                      />
                    </CustomPanel>
                  </div>
                </div>
              </div>
              <div className="custom-hits-sort-by-container mt-4">
                <div className="custom-hits">
                  <div className="hide-on-desktop">
                    {(window.isPrerender || this.props.isMobile) && (
                      <InfiniteHits
                        minHitsPerPage={12}
                        filters={this.props.filters}
                        setShowSearch={this.props.setShowSearch}
                        searchParams={createURL(this.state.searchState)}
                      />
                    )}
                  </div>
                  {(window.isPrerender || !this.props.isMobile) && (
                    <div className="hide-on-mobile">
                      <CustomHits
                        Hits={Hits}
                        setShowSearch={this.props.setShowSearch}
                        searchParams={createURL(this.state.searchState)}
                      />
                      <Pagination
                        showLast={true}
                        totalPages={this.props.isMobile ? 4 : 10}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </InstantSearch>
        </div>
      </SearchWrapper>
    );
  }
}

export default Search;
